(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("presentation-request", [], factory);
	else if(typeof exports === 'object')
		exports["presentation-request"] = factory();
	else
		root["presentation-request"] = factory();
})(this, function() {
return 